<template>

  <SortableGrid 
      :heroes="heroes"
      :columns="columns"
      :filterKey="filterKey"
  />
</template>

<script>
import SortableGrid from '@/components/SortableGrid.vue'
import getTeamsMixin from '@/data/get-teams-mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'TeamsGrid',
  mixins: [getTeamsMixin],
  components: {
    SortableGrid
  },
  data() {
    return {
        'filterKey': '',
        'columns': ['name', 'target', 'hr', 'points', 'projectedPoints', 'percentOfTarget', 'plateAppearances', 'games']
    };
  },
  computed: {
    heroes() {
      return this.$store.state.teamData.teamData.teams ? this.$store.state.teamData.teamData.teams: []
    },
  },
  created() {
    // Ensure data is loaded when this view is created
    this.ensureDataLoaded()
  },
  methods: {
    ...mapActions('teamData', ['initializeYearFromStorage']),
    async ensureDataLoaded() {
      // Check if we have data, if not, initialize it
      if (!this.teamData || Object.keys(this.teamData).length === 0) {
        await this.initializeYearFromStorage()
      }
    }
  }
}
</script>

<style lang="scss">
td.target, td.hr, td.points, td.projectedPoints, td.plateAppearances, td.games {
  text-align: right;
  width: 100;
}
</style>